import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Button } from '@one-thd/sui-atomic-components';
import { SweepstakesDrawer } from './SweepstakesDrawer';
import { SWEEPSTAKES_SURVEY_CONTENT } from '../../../core/Data/SweepstakesMockData';
import { SWEEPSTAKES_CONSTANTS } from '../../../core/Constants';

export const SweepstakesSurveyDrawer = ({
  isOpen,
  onClose,
  onComplete,
  title,
  content,
  ctaTitle,
  heroImage,
}) => {
  const handleComplete = () => {
    if (onComplete) {
      onComplete();
    }
  };

  const displayTitle = title || SWEEPSTAKES_SURVEY_CONTENT.title;
  const displayContent = content || SWEEPSTAKES_SURVEY_CONTENT.content;
  const displayCtaTitle = ctaTitle || SWEEPSTAKES_SURVEY_CONTENT.ctaTitle;

  const footerContent = (
    <Button
      variant="primary"
      fullWidth
      onClick={handleComplete}
      data-testid="sweepstakes-survey-complete-button"
    >
      {displayCtaTitle}
    </Button>
  );

  return (
    <SweepstakesDrawer
      isOpen={isOpen}
      onClose={onClose}
      drawerTitle={SWEEPSTAKES_CONSTANTS.DRAWER_TITLES.SWEEPSTAKES_SURVEY}
      sweepstakesTitle={title || SWEEPSTAKES_SURVEY_CONTENT.title}
      heroImage={heroImage}
      footerContent={footerContent}
    >
      <div className="sui-space-y-4" data-testid="sweepstakes-survey-content">
        {displayContent && (
          <Typography variant="body-sm">
            {displayContent}
          </Typography>
        )}
      </div>
    </SweepstakesDrawer>
  );
};

SweepstakesSurveyDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onComplete: PropTypes.func,
  title: PropTypes.string,
  content: PropTypes.string,
  ctaTitle: PropTypes.string,
  heroImage: PropTypes.string,
};

SweepstakesSurveyDrawer.defaultProps = {
  onComplete: null,
  title: null,
  content: null,
  ctaTitle: null,
  heroImage: null,
};